import React, { useState,useEffect } from 'react';
import Chart from 'react-apexcharts';
import {Fetchexecutequery} from '../../../services/process/BRS1/brsService7';
import Modal from 'react-bootstrap/Modal';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'semantic-ui-css/semantic.min.css';
import { Button} from 'semantic-ui-react';
import * as XLSX from 'xlsx';
import axios from "axios";

const DualGroupedBarChart = ({query1,query2,headers,data1,data2}) => {
  const [clickedData, setClickedData] = useState(null); // Store clicked data
  const [show, setShow] = useState(false);
  const [extGridData, setExtGridData] = useState([]);
  const [modelcolumnnames, setmodelcolumnnames] = useState([]);
  const [seriesname1, setSeriesname] = useState('');
  const [filtervalue1, setfilterValue] = useState('');
  const handleClose = () => {
    setShow(false);
    setfilterValue('');
  }
const allData = [
  ...data1,
  ...data2
];


const roundToNearest = (value,multiple) => {
  // Round value to the nearest 200,000 (or any other multiple you'd prefer)
  return Math.round(value / multiple)*multiple;
};
const minVariance1 = Math.min(...allData);
const maxVariance1 = Math.max(...allData);


useEffect(() => {
  if (seriesname1 && filtervalue1) {
    datainfo(seriesname1, filtervalue1); // Fetch data whenever query1/query2 or filter values change
  }
}, [seriesname1, filtervalue1, query1, query2]); // Dependencies: seriesname, filtervalue, query1, query2


  function datainfo(seriesname,filtervalue) {
    setExtGridData([]);
    console.log("aging query",seriesname,filtervalue,query1,query2)
    let selectedQuery;

if (seriesname === 'book') {
    selectedQuery = query2; // Assign query1 when seriesname is 'erp'
} else {
    selectedQuery = query1; // Otherwise, assign query2
}
console.log("Selected query:", selectedQuery);
if (seriesname === 'book') {
    seriesname = 'erp'; // Assign query1 when seriesname is 'erp'
}
    const dynamicQuery = selectedQuery.replace('${tableName}', seriesname).replace('${filterValue}', filtervalue);
    console.log("dynamic query",dynamicQuery,seriesname,filtervalue)

    let payload = {
      query : dynamicQuery
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          // let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
          
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  const intColumnDefs3 = React.useMemo(() => {
    if (extGridData && extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [extGridData]);


  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
      var workBook = XLSX.utils.book_new();
      var workSheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
      XLSX.writeFile(workBook, excelFileName);
      return true;
    }
    catch
    {
      return false;
    }
  }


  function exportToExcel() {
    let fileNameChange = "Report.xlsx";
    let sheetName = "sheet";

    let excelExportData = [];

    for (let i = 0; i < extGridData?.length; i++) {
      let data = {};
      for (let key in extGridData[i]) {
        for (let j = 0; j < modelcolumnnames?.length; j++) {
          if (key === modelcolumnnames[j]["field"]) {
            data[modelcolumnnames[j]["headerName"]] = extGridData[i][key]
          }
        }
      }

      excelExportData.push(data);
    };

    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

  }


  const options = {
    chart: {
      toolbar: {
        show: false, // Hide the toolbar
      },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          // Extract the indices for the clicked point
          const seriesIndex = config.seriesIndex; // Index of the clicked series
          const dataPointIndex = config.dataPointIndex; // Index of the clicked data point

          // Access the series name and value of the clicked bar
          const seriesNames = config.w.config.series[seriesIndex].name.toLowerCase();
          const values = config.w.config.series[seriesIndex].data[dataPointIndex];

          // Access the x-axis label (category) directly from xaxis.categories
          const xAxisValues = config.w.config.xaxis.categories[dataPointIndex];

          // Log to the console for debugging
  	  setSeriesname(seriesNames);
          setfilterValue(xAxisValues);

          setClickedData({
            seriesNames,
            xAxisValues,
            values
          });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        endingShape: 'rounded',
        dataLabels: {
          enabled: false, // Disable data labels to hide the values inside the bars
        },
      },
    },
 tooltip: {
    shared: true, // Allow shared tooltips for multiple bars in a group
    intersect: false, // Tooltip will display when hovering anywhere in the bar area
     y: {
        formatter: function (val) {
          if (val !== undefined && val !== null) {
          // Convert the value to crores
          return (val / 10000000).toFixed(2) + ' Cr';  // Format the value in crores
        }
        return '';
        // Format tooltip values as currency
        },
      },
  },
    xaxis: {
      categories: headers, // Categories (x-axis values)
    },
    yaxis: {
      title: {
        text: 'Amount (in Crores)',
      },
labels: {
      formatter: function (val) {
        // Convert the value to crores and return formatted label
        return (val / 10000000).toFixed(2) + ' Cr'; // Format the Y-axis labels in crores
      },
    },

    },
    dataLabels: {
      enabled: false, // Disable data labels to hide the values inside the bars
    },
  };

  const series = [
    {
      name: 'Book',
      data: data1,
      color: '#FF220C',
    },
    {
      name: 'Bank',
      data: data2,
      color: '#030B49',
    },
  ];

  return (
    <div>
      <Chart options={options} series={series} type="bar" height={200} />

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-11'>

            </div>
            <div className='col-md-1'>
              <a onClick={exportToExcel}>
                <i class='fas fa-file-excel' style={{ fontSize: '30px', color: 'green' }}></i>
              </a>
            </div></div>
          <div className="ag-theme-alpine"
            style={{ height: '400px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={modelcolumnnames}
              rowData={extGridData}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DualGroupedBarChart;